import React from "react";
import { IoIosBriefcase, IoIosHome, IoIosSettings } from "react-icons/io";
import {
  NavLink,
  Link,
  useLocation,
} from "react-router-dom/cjs/react-router-dom.min";
import { RiBankCardFill } from "react-icons/ri";

export const BottomNav = () => {
  const pathname = useLocation().pathname;
  const navLinks = [
    {
      name: "home",
      Iconpath: IoIosHome,
      Iconpathactive: "/img/icons/navhomeactive.svg",
    },
    {
      name: "transaction",
      Iconpath: RiBankCardFill,
      Iconpathactive: "/img/icons/navwalletactive.svg",
    },
    {
      name: "investment",
      Iconpath: IoIosBriefcase,
      Iconpathactive: "/img/icons/navinvestactive.svg",
    },
    {
      name: "setting",
      Iconpath: IoIosSettings,
      Iconpathactive: "/img/icons/navinvestactive.svg",
    },
  ];
  return (
    <div className="fixed mx-auto max-w-sm bg-white bottom-0 w-full py-2 border-t">
      <div className="grid grid-cols-5 justify-items-center mx-auto">
        {navLinks.map(({ name, Iconpath, Iconpathactive }, index) => (
          <NavLink
            key={index}
            to={`/dashboard/${name}`}
            activeClassName="text-primary"
            className="self-center font-body font-light"
          >
            <>
              {pathname === `/dashboard/${name}` ? (
                <div className="flex flex-col items-center">
                  <Iconpath className="text-primary text-3xl" />
                  <p className="text-xs">
                    {name.charAt(0).toUpperCase() + name.slice(1)}
                  </p>
                </div>
              ) : (
                <div className="flex flex-col items-center">
                  <Iconpath className="text-gray-400 text-3xl" />
                  <p className="text-xs">
                    {name.charAt(0).toUpperCase() + name.slice(1)}
                  </p>
                </div>
              )}
            </>
          </NavLink>
        ))}
        <div></div>
      </div>
    </div>
  );
};

export const OnboardingNav = () => {
  const pathname = useLocation().pathname;
  const navLinks = [
    {
      name: "",
      Iconpath: "/img/new/icons/ellipse.svg",
      Iconpathactive: "/img/new/icons/rectangle.svg",
    },
    {
      name: "home2",
      Iconpath: "/img/new/icons/ellipse.svg",
      Iconpathactive: "/img/new/icons/rectangle.svg",
    },
    {
      name: "home3",
      Iconpath: "/img/new/icons/ellipse.svg",
      Iconpathactive: "/img/new/icons/rectangle.svg",
    },
  ];
  return (
    <div className="self-end flex gap-x-1">
      {navLinks.map(({ name, Iconpath, Iconpathactive }, index) => (
        <NavLink key={index} to={`/${name}`}>
          <>
            {pathname === `/${name}` ? (
              <img src={Iconpathactive} />
            ) : (
              <img src={Iconpath} />
            )}
          </>
        </NavLink>
      ))}
    </div>
  );
};
